import { render, staticRenderFns } from "./CRUDBath.vue?vue&type=template&id=362a4d82&scoped=true&"
import script from "./CRUDBath.vue?vue&type=script&lang=ts&"
export * from "./CRUDBath.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362a4d82",
  null
  
)

export default component.exports